import React, { FC, useState } from "react";

import { AttentionBanner, Icon } from "../../common";
import { KycModal } from "../../modals";

export const VerifyAccountBanner: FC = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="w-[340px] h-[244px]">
      <AttentionBanner
        heading={
          <div className="flex items-center gap-4">
            <Icon icon="person" size={24} />
            Verify your account
          </div>
        }
        action={{
          label: "Verify",
          onClick: () => setShowModal(true),
        }}
      >
        Send invoices and get payments without limits
      </AttentionBanner>

      {showModal && (
        <KycModal isOpen={showModal} close={() => setShowModal(false)} />
      )}
    </div>
  );
};
